import { render, staticRenderFns } from "./SubstancesReviewSection.vue?vue&type=template&id=1e6fc6f3&scoped=true&"
import script from "./SubstancesReviewSection.vue?vue&type=script&lang=js&"
export * from "./SubstancesReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./SubstancesReviewSection.vue?vue&type=style&index=0&id=1e6fc6f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6fc6f3",
  null
  
)

export default component.exports